var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5330_3239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5330_3239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 6.62498V17.375C21 17.8416 20.846 18.2293 20.538 18.538C20.2293 18.846 19.8417 19 19.375 19H4.625C4.15833 19 3.771 18.846 3.463 18.538C3.15433 18.2293 3 17.8416 3 17.375V6.62498C3 6.15831 3.15433 5.77098 3.463 5.46298C3.771 5.15431 4.15833 4.99998 4.625 4.99998H19.375C19.8417 4.99998 20.2293 5.15431 20.538 5.46298C20.846 5.77098 21 6.15831 21 6.62498ZM4 8.79998H20V6.62498C20 6.45831 19.9373 6.31264 19.812 6.18798C19.6873 6.06264 19.5417 5.99998 19.375 5.99998H4.625C4.45833 5.99998 4.31267 6.06264 4.188 6.18798C4.06267 6.31264 4 6.45831 4 6.62498V8.79998ZM4 11.2V17.375C4 17.5416 4.06267 17.6873 4.188 17.812C4.31267 17.9373 4.45833 18 4.625 18H19.375C19.5417 18 19.6873 17.9373 19.812 17.812C19.9373 17.6873 20 17.5416 20 17.375V11.2H4Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.3a6d97ac42c9c46b470218b24e2598e3.svg";
export { ForwardRef as ReactComponent };